/*eslint-disable*/
import api from '../'

class chooseItRightGameItems {
    // POST: couples
    static getItemsByRequest (params) {
        return api.axios.get('/chooseItRight/items', { params }).then(response => response.data.items);
    }
}

export default chooseItRightGameItems;
